import { environment } from '../../../environments/environment';

const APPWRITE_STORAGE_PATH_SEGMENT = '/storage/buckets/';

export function isAppwriteStorageUrl(url: string | null | undefined): boolean {
    return !!url && url.includes(APPWRITE_STORAGE_PATH_SEGMENT);
}

export function normalizeAppwriteStorageUrl(url: string | null | undefined): string {
    if (!url || !isAppwriteStorageUrl(url)) {
        return url || '';
    }

    try {
        const parsedUrl = new URL(url);
        const endpoint = new URL(environment.appwrite.endpoint);
        const storagePathIndex = parsedUrl.pathname.indexOf(APPWRITE_STORAGE_PATH_SEGMENT);

        if (storagePathIndex === -1) {
            return url;
        }

        parsedUrl.protocol = endpoint.protocol;
        parsedUrl.host = endpoint.host;
        parsedUrl.pathname = `${endpoint.pathname.replace(/\/$/, '')}${parsedUrl.pathname.slice(storagePathIndex)}`;
        parsedUrl.searchParams.set('project', environment.appwrite.projectId);

        return parsedUrl.toString();
    } catch {
        return url;
    }
}

export function toAppwriteStoragePreviewUrl(url: string | null | undefined, width = 320): string {
    const normalizedUrl = normalizeAppwriteStorageUrl(url);
    if (!normalizedUrl || !isAppwriteStorageUrl(normalizedUrl)) {
        return normalizedUrl;
    }

    try {
        const parsedUrl = new URL(normalizedUrl);
        if (!/\/(view|download|preview)\/?$/.test(parsedUrl.pathname)) {
            return normalizedUrl;
        }

        parsedUrl.pathname = parsedUrl.pathname.replace(/\/(view|download|preview)\/?$/, '/preview');
        parsedUrl.searchParams.set('width', String(Math.max(1, Math.round(width))));
        parsedUrl.searchParams.set('quality', '82');
        return parsedUrl.toString();
    } catch {
        return normalizedUrl;
    }
}
